import { postApiGalaxyServer } from 'services';

export interface GrafanaPayload {
  databaseName: string; // Grafana datasource display name
  engine?: string;
  host: string; // Database server address
  database: string; // Database name
  username: string; // Database username
  password: string; // Database password
}

export interface GrafanaSuccessResponse {
  message: string;
}

export interface GrafanaErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const createGrafanaDatasourceApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<GrafanaPayload>) => postApiGalaxyServer(`/grafana`, params, config, token);
